import PropTypes from "prop-types";
import { Button } from "@mui/material";

import "./printView.css";

export default function PrintButton({ onClose }) {
  return (
    <div
      className="printViewHide"
      style={{
        display: "flex",
        height: "50px",
        justifyContent: "flex-end",
        width: "100%",
        padding: "10px",
        backgroundColor: "white",
      }}
    >
      <Button onClick={onClose} sx={{ marginRight: "40px" }}>
        Back
      </Button>
      <Button
        color="secondary"
        onClick={() => window.print()}
        variant="contained"
      >
        Print / Save PDF
      </Button>
    </div>
  );
}

PrintButton.propTypes = {
  onClose: PropTypes.func.isRequired,
};
